import styled from 'styled-components'

import { Flex } from '@/atoms/layout'

export const StyledHeader = styled(Flex)`
  padding: 0 ${({ theme }) => theme.space.S8};
  justify-content: space-between;
  align-items: center;
`

export const StyledButton = styled.button`
  display: block;
  width: 24px;
  height: 24px;
  color: ${({ theme }) => theme.colors.label};
  background: ${({ theme }) => theme.colors.bgLight};
  padding: 0;
  border: 0;
  border-radius: 5px;
  cursor: pointer;
  outline: none;

  &:disabled {
    opacity: 0.5;
  }
`

export const StyledSelect = styled.select`
  appearance: none;
  border: 0;
  background: transparent;
  padding: 8px;
  border-radius: 4px;
  outline: 0;
  color: ${({ theme }) => theme.colors.label};
  cursor: pointer;
  text-align: center;

  &:hover {
    background-color: ${({ theme }) => theme.colors.bgLight};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.bgLight};
  }

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.greyLight};
    border: 1px solid ${({ theme }) => theme.colors.bgDark};
  }

  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.bgDark};
  }
`
